// // ViewAdmin.js
// import React, { useState, useEffect } from "react";
// import "../Admin Profile/Adminprofile.css";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchProfileData } from "../../../Services/Profile/ProfileApi";
// import { useNavigate , useLocation} from "react-router-dom";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import { setCommunity } from "../../../Services/Community/CommunitySlice/communitySlice"; // Update path as per your project

// function ViewAdmin() {
//   const dispatch = useDispatch();
//   const { data } = useSelector((state) => state.fetchProfileData);
// //   const community = useSelector((state) => state.community.community); // Access entire community object from Redux store
//   const [profile, setProfile] = useState({});
//   const [loading, setLoading] = useState(true);
//   const [userEmail, setuseremail] = useState();
//   const userId = localStorage.getItem("user_id");
//   const userType = localStorage.getItem("user_type");

//   const navigate = useNavigate();
//   const location = useLocation();
//   const { community } = location.state; // Access the state
 
//   console.log(community , "community")
//   useEffect(() => {
//     dispatch(fetchProfileData(userId)).finally(() => setLoading(false));
//   }, [dispatch]);

//   useEffect(() => {
//     if (data) {
//       setProfile(data.user_details);
//       setuseremail(data?.user_details?.email);
//     }
//   }, [data]);

//   const handleSendEmail = () => {
//     if (data) {
//       navigate(`/change-password?email=${encodeURIComponent(userEmail)}`);
//     }
//   };

//   const handleUpdateProfile = () => {
//     navigate("/admin/update-profile", { state: { profileData: profile } });
//   };

//   const handleCommunityView = () => {
//     alert(`Viewing community with ID: ${community.id}\nName: ${community.name}\nDescription: ${community.description}`);
//     navigate(`/admin/view-community/${community.id}`); // Use community.id for navigation
//   };

//   return (
//     <>
//       <div className="admin-profile-section">
//         <div className="back-btn">
//           <button onClick={() => navigate(-1)} className="back-btn-button">
//             <ArrowBackIcon className="left-icon" />
//             Back
//           </button>
//         </div>
//         <div className="admin-profile-wrapper">
//           <div className="admin-profile-inner">
//             <div className="admin-content-block d-flex">
//               <div className="admin-pic-name">
//                 <div className="admin-img">
//                   {/* <img
//                     src={profile?.image || default_pfp}
//                     alt="Profile-picture"
//                     onError={(e) => {
//                       e.target.onerror = null;
//                       e.target.src = default_pfp;
//                     }}
//                   /> */}
//                 </div>
//                 <div className="admin-name text-center">
//                   {community?.first_name} {community?.last_name}
//                 </div>
//                 <div className="admin-designation text-center">{userType}</div>
//               </div>
//               <div className="admin-main-details">
//                 <div className="personal-details">Personal Details</div>
//                 <div className="table-admin">
//                   <div className="table-admin-inner">
//                     <table className="table table-borderless table-desktop-view">
//                       <thead>
//                         <tr>
//                           <th scope="col">First Name</th>
//                           <th scope="col">Last Name</th>
//                           <th scope="col">Email address</th>
//                           <th scope="col">Phone Number</th>
                        
//                         </tr>
//                       </thead>
//                       <tbody>
//                         <tr>
//                           <td>{community?.first_name} </td>
//                           <td>{community?.last_name}</td>
//                           <td>{community?.email}</td>
//                           <td>{community?.phone_number}</td>
//                         </tr>
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="change-edit-btns d-flex gap-3 justify-content-end ">
//               <div className="change-pw-btn text-end mt-3">
//                 <button onClick={handleSendEmail}>Change Password</button>
//               </div>
//               <div className="editprofile-btn text-end mt-3">
//                 <button onClick={handleUpdateProfile}>Edit Profile</button>
//               </div>
//               <div className="view-community-btn text-end mt-3">
//                 <button onClick={handleCommunityView}>View Community</button> {/* View Community Button */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ViewAdmin;
import React, { useEffect, useState } from "react";
import { Input, InputLabel } from "@mui/material";
import "../../CreateUser/CreateUser.css";
import { State, City } from "country-state-city";
import { useDispatch } from "react-redux";
import { useNavigate,useLocation } from "react-router-dom";
import { CommunityOwner, SuperAdmin } from "../../../Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function ViewAdmin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});

  const location = useLocation();
  const community  = location.state?.community; // Access the state
  
 

  // State for form inputs
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    state: "",
    location: "",
    phone_number: "",
  });

   useEffect(()=>{
    if(community){

  
    setFormData({
        first_name: community?.first_name,
        last_name: community?.last_name,
        email: community?.email,
        state: community?.state,
        location: community?.location,
        phone_number: community?.phone_number,
      });
    }
    },[])
  
  const userId = localStorage.getItem("user_id");
  const user_type = localStorage.getItem("user_type");

  const handleStateChange = (e) => {
    const selectedStateName = e.target.value;
    const selectedState = states.find(
      (state) => state.name === selectedStateName
    );

    setFormData((prevData) => ({
      ...prevData,
      state: selectedStateName, // Store state name for submission
      city: "",
    }));

    if (selectedState) {
      const stateCities = City.getCitiesOfState("US", selectedState.isoCode);
      setCities(stateCities);
    }

    // Clear validation error for state
    setErrors((prevErrors) => ({
      ...prevErrors,
      state: "",
      city: "", // Reset city error since state is changing
    }));
  };

  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      city: selectedCity,
    }));

    // Clear validation error for city
    setErrors((prevErrors) => ({
      ...prevErrors,
      city: "",
    }));
  };

  const handleTypeChange = (e) => {
    const selectedType = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      type: selectedType,
    }));

    // Clear validation error for type
    setErrors((prevErrors) => ({
      ...prevErrors,
      type: "",
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    // Clear validation error for the current input
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    const errors = {};

    // if (!formData.first_name.trim()) {
    //   errors.last_name = "First Name is required";
    // }
    // if (!formData.last_name.trim()) {
    //   errors.last_name = "Last Name is required";
    // }
    // if (!formData.state) {
    //   errors.state = "State is required";
    // }
    // if (!formData.email) {
    //   errors.email = "email is required";
    // }
    // if (!formData.state) {
    //   errors.state = "state is required";
    // }
    // if (!formData.city) {
    //   errors.city = "City is required";
    // }
    // if (!formData.type) {
    //   errors.type = "Type is required";
    // }
    // if (!formData.phone_number || formData.phone_number <= 0) {
    //   errors.phone_number = "Phone Number must be a positive number";
    // }

    setErrors(errors); // Update error state

    return Object.keys(errors).length === 0; // Return true if no errors
  };

  const handleSubmit = (e) => {
    navigate(`/super-admin/update-user/`, {
      state: { community },
    });
 
  };

  useEffect(() => {
    const usaStates = State.getStatesOfCountry("US");
    setStates(usaStates);
  }, []);

 

  return (
    <>
      <div className="back-btn">
        <button onClick={() => navigate(-1)} className="back-btn-button">
          {/* <img src={chevronleft} alt="chevron-left" className="left-icon" />
           */}
          <ArrowBackIcon className="left-icon" />
          Back
        </button>
      </div>
      <div className="community-section">
        <div className="community-inner-wrap">
          <div className="add-new-community d-flex justify-content-between align-items-center">
            <div className="community-heading create-new">User Details</div>
          </div>
          <div className="create-community-name-table">
            <div className="create-comm-inner-wrap">
              <form className="create-community-form">
                {/* First Name */}
                <div className="main-community-block">
                  <div className="d-flex align-items-center community-city-blk">
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        First Name
                      </InputLabel>
                
                      {formData.first_name}
                      {errors.first_name && (
                        <div className="error-text">{errors.first_name}</div>
                      )}
                    </div>

                    {/* Last Name */}

                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">
                        Last Name
                      </InputLabel>
                      {/* <Input
                        id="last_name"
                        className="input-box"
                        placeholder="Enter provider last name"
                        type="text"
                        name="last_name"
                        value={formData.last_name}
                        onChange={handleInputChange}
                      /> */}
                      {formData.last_name}
                      {errors.last_name && (
                        <div className="error-text">{errors.last_name}</div>
                      )}
                    </div>
                    {/* Gender */}
                    {/* <div className="comm-name-blk">
                     
                      <InputLabel htmlFor="type">Gender</InputLabel>
                      {formData.gender}
                      {errors.type && (
                        <div className="error-text">{errors.type}</div>
                      )}
                     
                    </div> */}
                  </div>
                  <div className="state-type-unit-blk d-flex align-items-center">
                    {/* Email */}
                    <div className="comm-name-blk">
                      <InputLabel htmlFor="community-name">Email</InputLabel>
                     
                      {formData.email}
                      {errors.email && (
                        <div className="error-text">{errors.email}</div>
                      )}
                    </div>
                    {/* Phone */}

                    <div className="comm-name-blk">
                      <InputLabel htmlFor="unit">Phone</InputLabel>
                
                      {formData.phone_number}
                      {errors.phone_number && (
                        <div className="error-text">{errors.phone_number}</div>
                      )}
                    </div>
                  </div>
                  <br></br>
                  <div className="state-type-unit-blk d-flex align-items-center">
                    {/* State */}
                    <div className="city-name-blk">
                      <InputLabel htmlFor="state">State</InputLabel>
                      {formData.state}
                      {errors.state && (
                        <div className="error-text">{errors.state}</div>
                      )}
                    </div>

                    {/* City */}
                    <div className="city-name-blk">
                      <div className="mb-6">
                        <InputLabel htmlFor="city">
                        Location 
                        </InputLabel>
                        {/* <select
                          id="city"
                          name="city"
                          className="dropdown-box"
                          value={formData.city}
                          onChange={handleCityChange}
                        >
                          <option value="" disabled>
                            Select city
                          </option>
                          {cities.map((city) => (
                            <option key={city.id} value={city.name}>
                              {city.name}
                            </option>
                          ))}
                        </select> */}
                        
                        {formData.location}
                        {errors.location && (
                          <div className="error-text">{errors.location}</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="create-comm-btn">
              <button
                type="submit"
                class="blue-filled-btn"
                onClick={handleSubmit}
              >
                Edit
              </button>
              {/* <button
                type="submit"
                class="blue-filled-btn"
                onClick={handleSubmit}
              >
                Cancel
              </button> */}
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </>
  );
}

export default ViewAdmin;
